/*
 * Product recommendations for the related and complementary sections, and the
 * complementary block inside the product information section.
 *
 * The `recommendations` Liquid object is only populated when Shopify renders a
 * section through the product recommendations route, so the section has to ask
 * for it. Only the intent the merchant chose is requested: "You may also like"
 * means the related products from Search & Discovery, never a substitute. When
 * there are none the section keeps whatever it rendered, which is the optional
 * collection fallback or nothing at all.
 */
(function () {
  'use strict';

  // Both sections load this file, so only the first copy does the work.
  if (window.themeProductRecommendations) return;
  window.themeProductRecommendations = true;

  var SECTION = '[data-product-recommendations]';
  var BODY = '[data-recommendations-body]';
  var GRID = '[data-recommendations-grid]';

  function request(section, url) {
    fetch(url)
      .then(function (response) {
        if (!response.ok) throw new Error('Recommendations failed: ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        // The product information section can hold several complementary
        // blocks, so match the returned copy by id before taking the first.
        var fresh = (section.id && doc.getElementById(section.id)) || doc.querySelector(SECTION);
        var grid = fresh ? fresh.querySelector(GRID) : null;

        if (grid && grid.children.length) swap(section, fresh);
      })
      .catch(function () {
        /* Leave the section exactly as the server rendered it. */
      });
  }

  function swap(section, fresh) {
    var target = section.querySelector(BODY);
    var source = fresh.querySelector(BODY);
    if (!target || !source) return;

    target.innerHTML = source.innerHTML;
    section.hidden = false;
  }

  function load(section) {
    if (section.dataset.loaded === 'true') return;
    if (!section.dataset.url) return;

    section.dataset.loaded = 'true';
    request(section, section.dataset.url);
  }

  function observe(section) {
    if (!('IntersectionObserver' in window)) {
      load(section);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          load(entry.target);
        });
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(section);
  }

  function init(root) {
    if (!window.fetch || !window.DOMParser) return;

    var sections = (root || document).querySelectorAll(SECTION);
    Array.prototype.forEach.call(sections, function (section) {
      // A hidden section has no box to intersect with, so load it right away.
      if (section.hidden) {
        load(section);
        return;
      }
      observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  // Re-run when the section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
